<template>
  <div>
    <!-- <Header /> -->

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="p-3 2xl:p-10">
          <div class="flex space-x-4 my-4">
            <button
              class="px-4 py-2 rounded-xl text-xs font-semibold focus:outline-none border"
              :class="
                tab === 'assignment'
                  ? 'bg-blues text-white border-blue-600'
                  : 'bg-gray-100 text-black border-gray-300 hover:bg-blue-100 hover:border-blue-400'
              "
              @click="triggerPage('assignment')"
            >
              Assignment
            </button>

            <button
              class="px-4 py-2 rounded-xl text-xs font-semibold focus:outline-none border"
              :class="
                tab === 'assessment'
                  ? 'bg-blues text-white border-blue-600'
                  : 'bg-gray-100 text-black border-gray-300 hover:bg-blue-100 hover:border-blue-400'
              "
              @click="triggerPage('assessment')"
            >
              Assessment
            </button>
          </div>
           <div
            class="w-full bg-[#edf8ff] flex justify-center gap-5 items-center px-2 py-2 lg:px-8 rounded-md"
            v-if="response_message"
          >
            <h2 class="text-blues text-center">
              {{ response_message }}
            </h2>

            <router-link
              :to="{ name: 'DownloadHistory' }"
              class="text-blue-600 text-xs underline font-bold"
            >
              Download History
            </router-link>
          </div>

          <div v-if="tab === 'assignment'" class="space-y-4">
            <div class="p-4 flex flex-col gap-5">
              <div class="flex justify-end">
                <div class="flex gap-4 flex-wrap md:flex-nowrap">
                  <div
                    @click="assignmentdownload()"
                    class="bg-blues w-full md:w-auto justify-center text-white rounded-2xl py-1.5 px-5 flex items-center gap-2 cursor-pointer"
                  >
                    <img src="@/assets/newd/download1.png" alt="" />
                    <p class="text-sm text-white">Download</p>
                  </div>
                  <div class="relative w-full md:max-w-64">
                    <form @submit.prevent="getassignment(1)">
                      <input
                        type="text"
                        placeholder="Search"
                        id="search"
                        v-model="search_list"
                        @input="getassignment(1)"
                        class="w-full pl-4 pr-10 py-1.5 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
                      />
                      <button type="submit" class="">
                        <div
                          class="absolute right-3 top-2.5 h-4 w-4 text-gray-400"
                        >
                          <img
                            src="@/assets/search_icon1.svg"
                            alt=""
                            srcset=""
                          />
                        </div>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
              <div v-if="assignments.length > 0" class="">
                <div
                  class="overflow-x-auto rounded-lg shadow border border-gray-200"
                >
                  <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-100 whitespace-nowrap">
                      <tr class="text-left bg-blues text-white text-sm">
                        <th class="px-4 py-2">S.No</th>
                        <th class="px-4 py-2">Assignment Title</th>
                        <th class="px-4 py-2 text-center">Count</th>
                        <th class="px-4 py-2 text-center">Download</th>
                        <th class="px-4 py-2">Created Date</th>
                        <th class="px-4 py-2">Due Date</th>
                      </tr>
                    </thead>
                    <tbody
                      class="divide-y divide-gray-100 text-sm whitespace-nowrap"
                    >
                      <tr
                        v-for="(assignment, index) in assignments"
                        :key="index"
                        class="hover:bg-gray-50"
                      >
                        <td class="px-4 py-2 font-medium text-gray-800">
                          {{ (currentPage - 1) * 10 + index + 1 }}
                        </td>
                        <td class="px-4 py-2">
                          <router-link
                            :to="{
                              name: 'AssignmentGrade',
                              params: {
                                assignment_id: assignment.id,
                                assignment_title: assignment.title,
                              },
                            }"
                            class="text-blue-600 cursor-pointer"
                          >
                            {{ assignment.title }}
                          </router-link>
                        </td>
                        <td class="px-4 py-2 text-center text-gray-700">
                          {{ assignment.completed_count }} /
                          {{ assignment.student_count }}
                        </td>
                        <td
                          class="px-4 py-2 text-blue-600 text-center cursor-pointer"
                        >
                          <div
                            class="inline-block hover:text-blue-800"
                            @click="Assdownload(assignment.id)"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-5 w-5 mx-auto"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                              />
                            </svg>
                          </div>
                        </td>
                        <td class="px-4 py-2 text-gray-600">
                          {{ formatDate(assignment.created_at) }}
                        </td>
                        <td class="px-4 py-2 text-gray-600">
                          {{ assignment.duedate }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="getassignment"
                />
              </div>
              <div v-else>NO Data Found</div>
            </div>
          </div>

          <div v-else class="space-y-4">
            <div class="p-4 flex flex-col gap-5">
              <div class="flex justify-end">
                <div class="flex gap-4 flex-wrap md:flex-nowrap">
                 <div
                    @click="assessmentdownload()"
                    class="bg-blues w-full md:w-auto justify-center text-white rounded-2xl py-1.5 px-5 flex items-center gap-2 cursor-pointer"
                  >
                    <img src="@/assets/newd/download1.png" alt="" />
                    <p class="text-sm text-white">Download</p>
                  </div>
                <div class="relative w-full md:max-w-64">
                  <form @submit.prevent="getassessment(1)">
                    <input
                      type="text"
                      placeholder="Search"
                      id="search"
                      v-model="searching"
                      @input="getassessment(1)"
                      class="w-full pl-4 pr-10 py-1.5 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
                    />
                    <button type="submit" class="">
                      <div
                        class="absolute right-3 top-2.5 h-4 w-4 text-gray-400"
                      >
                        <img src="@/assets/search_icon1.svg" alt="" srcset="" />
                      </div>
                    </button>
                  </form>
                </div>
                </div>
              </div>
              <div class="" v-if="assessments.length > 0">
                <div
                  class="overflow-x-auto rounded-lg shadow border border-gray-200"
                >
                  <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-100 whitespace-nowrap">
                      <tr class="text-left bg-blues text-white text-sm">
                        <th class="px-4 py-2">S.No</th>
                        <th class="px-4 py-2">Quizs Title</th>
                        <th class="px-4 py-2 text-center">Count</th>
                        <th class="px-4 py-2 text-center">Download</th>
                        <th class="px-4 py-2">Created Date</th>
                      </tr>
                    </thead>
                    <tbody
                      class="divide-y divide-gray-100 text-sm whitespace-nowrap"
                    >
                      <tr
                        v-for="(assessment, index) in assessments"
                        :key="index"
                        class="hover:bg-gray-50"
                      >
                        <td class="px-4 py-2 font-medium text-gray-800">
                          {{ (currentPage1 - 1) * 10 + index + 1 }}
                        </td>
                        <td class="px-4 py-2">
                          <router-link
                            :to="{
                              name: 'AssessmentMark',
                              params: {
                                assessment_id: assessment.id,
                                assessment_title: assessment.name,
                              },
                            }"
                            class="text-blue-600 cursor-pointer"
                          >
                            {{ assessment.name || "Na" }}
                          </router-link>
                        </td>
                        <td class="px-4 py-2 text-center text-gray-700">
                          {{ assessment.completed_count || 0 }} /
                          {{ assessment.student_count || 0 }}
                        </td>
                        <td
                          class="px-4 py-2 text-blue-600 text-center cursor-pointer"
                        >
                          <div
                            href="#"
                            class="inline-block hover:text-blue-800"
                            @click="Assessdownload(assessment.id)"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-5 w-5 mx-auto"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                              />
                            </svg>
                          </div>
                        </td>
                        <td class="px-4 py-2 text-gray-600">
                          {{ formatDate(assessment.timestamp) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <Pagination
                  :totalPages="totalPages1"
                  ref="paginationRef"
                  @page-changed="getassessment"
                />
              </div>
              <div v-else>NO Data Found</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    Pagination,
  },
  data() {
    return {
      userSelectList: [],

      messages: {
        text: "",
        type: "null",
      },
      loading: true,
      currentPage: 1,
      totalPages: 1,
      tab: "assignment",
      assignments: [],
      assessments: [],
      totalPages1: 1,
      currentPage1: 1,
      search_list: "",
      searching: "",
       response_message: "",
    };
  },
  async created() {
    await this.getassignment(1);
    await this.getassessment(1);
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    const fromTab = this.$route.query.fromTab;
    if (fromTab === "assignment" || fromTab === "assessment") {
      this.setTab(fromTab);
    }
  },

  methods: {
    setTab(view) {
      this.tab = view;
    },
    triggerPage(view) {
      this.setTab(view);
      this.$router.replace({ query: { ...this.$route.query, fromTab: view } });

      this.$nextTick(() => {
        if (view === "assignment" && this.$refs.paginationRef) {
          this.$refs.paginationRef.changePage(this.currentPage);
        } else if (view === "assessment" && this.$refs.paginationRef) {
          this.$refs.paginationRef.changePage(this.currentPage1);
        } else {
          console.warn("Relevant paginationRef is null");
        }
      });
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    },

    async getassignment(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/student_assignment_drade/?Key=${this.userInfo.token_key}&page=${page}&course_id__id=${this.course_id}&page=${page}&search=${this.search_list}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.totalPages = response.data.data?.total_page;
            this.assignments = response.data.data?.data?.data || [];
            console.log("this.studentList/////////:::::::", this.assignments);
          } else if (response.data.status == 400) {
            this.assignments = [];
          }
          this.loading = false;
        })

        .catch((error) => {
          console.error("Error:", error);
          this.assignments = [];
          this.loading = false;
        });
    },
    async getassessment(page) {
      this.currentPage1 = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/coursequize/grade/?Key=${this.userInfo.token_key}&page=${page}&course__id=${this.course_id}&page=${page}&search=${this.searching}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.totalPages1 = response.data.data?.total_page;
            this.assessments = response.data.data?.data?.data || [];
            console.log("this.studentList/////////:::::::", this.assessments);
          } else if (response.data.status == 400) {
            this.assessments = [];
          }
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error:", error);
          this.assessments = [];
          this.loading = false;
        });
    },
    async Assdownload(id) {
      window.location.href = `${process.env.VUE_APP_API}/student_assignment_drade/detail/?Key=${this.userInfo.token_key}&assignment_id=${id}&download=True&verify_status=accepted`;
    },

    async Assessdownload(id) {
      window.location.href = `${process.env.VUE_APP_API}/coursequize/taker/list/?Key=${this.userInfo.token_key}&completed=true&quiz__id=${id}&download=True`;
    },
      async assignmentdownload() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/assignments/download/all/?course_id=${this.course_id}&Key=${this.userInfo.token_key}`
        )
        .then((resp) => {
          if (resp) {
            this.response_message =
              "Your file is ready to download go to download history page";

            setTimeout(() => {
              this.response_message = "";
            }, 5000);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
      async assessmentdownload() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/quiz-feedback/download/?course_id=${this.course_id}&Key=${this.userInfo.token_key}`
        )
        .then((resp) => {
          if (resp) {
            this.response_message =
              "Your file is ready to download go to download history page";

            setTimeout(() => {
              this.response_message = "";
            }, 5000);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
